import useProgressPage from "./hooks/useProgressPage";
import PageContainer from "../../components/PageContainer";
import ProgressLine from "./ProgressLine";

const ProgressPage = () => {
  const { progress } = useProgressPage();

  return (
    <PageContainer header={"7th class curriculum"}>
      <div style={{ width: "100%" }}>
        {progress?.map((progressLine) => (
          <ProgressLine key={progressLine?.topic?.id} {...progressLine} />
        ))}
      </div>
    </PageContainer>
  );
};

export default ProgressPage;
